import req from "@/utils/request";

//  公众号列表
export const wxCountPage = (params) => req.post("/media-service/m/msMedia/wxCountPage", params);

//  公众号列表
export const selectListTree = (params) => req.post("/media-service/m/wxGrant/selectListTree", params);
